var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.link ? 'a' : 'div',{tag:"component",class:['zg-logo-card', {
    [`zg-logo-card--background-${_vm.background}`]: _vm.background,
    'zg-logo-card--with-text': _vm.text,
    'zg-logo-card--small': _vm.small
  }],attrs:{"href":_vm.link && _vm.link.href,"target":_vm.link && _vm.link.target,"nofollow":_vm.link && _vm.link.nofollow}},[_c('zg-image',_vm._b({attrs:{"lazy-load":""}},'zg-image',_vm.image,false)),_vm._v(" "),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }